const RootApi = process.env.REACT_APP_ROOT_API || "";
const RootApiAppointment = process.env.REACT_APP_ROOT_API_APPOINTMENT || "";
const RootApiAuth = process.env.REACT_APP_ROOT_API_AUTH || "";
const RootApiUser = process.env.REACT_APP_ROOT_API_USER || "";
const RootApiSuperUser = process.env.REACT_APP_ROOT_API_SUPERUSER || "";
const RootApiMedia = process.env.REACT_APP_ROOT_API_MEDIA || "";
const RootApiResource = process.env.REACT_APP_ROOT_API_RESOURCE || "";

export const AppConfig = {
  RootApi: RootApi,
  RootApiUser: RootApiUser,
  RootApiAppointment: RootApiAppointment,
  RootApiAuth: RootApiAuth,
  RootApiSuperUser: RootApiSuperUser,
  RootApiMedia: RootApiMedia,
  RootApiResource: RootApiResource,
};
